import { createRouter, createWebHistory } from "vue-router";

import Layout from "@/components/MNK/Layout/Home.vue";
import Landing from "@/components/MNK/Layout/Landing.vue";
import Contactus from "@/components/MNK/pages/Contactus.vue";
import AboutUs from "@/components/MNK/pages/aboutUs.vue";
import Service from "@/components/MNK/pages/Service.vue";
import Media from "@/components/MNK/pages/Media.vue";
import i18n from "@/i18n" 




const routes = [
  { path: "/", name: "landing", component: Landing },
  { path: "/home", name: "home", component: Layout, meta: { title: "RouteTitles.Home" } },
  { path: "/contact", name: "contact", component: Contactus, meta: { title: "RouteTitles.Contact" } },
  { path: "/about-us", name: "about-us", component: AboutUs, meta: { title: "RouteTitles.AboutUs" } },
  { path: "/services", name: "services", component: Service, meta: { title: "RouteTitles.Services" } },
  { path: "/media", name: "media", component: Media, meta: { title: "RouteTitles.Media" } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Global hook to update the page title
router.beforeEach((to, from, next) => {
  const baseTitle = 'MNK Agriventures'
  const title = to.meta.title ? i18n.global.t(to.meta.title) : ''
  document.title = title ? `${title} | ${baseTitle}` : baseTitle
  next()
})



export default router;
